<ui-form-field-layout
	[isRequired]="isRequired()"
	[title]="title()"
	[subtitle]="subtitle()"
	[isValid]="isValid()"
	[hint]="hint()"
	[suffix]="suffix()"
>
	<div class="ui-input" slot="input">
		@if (enableFlatPickr()) {
		<input
			type="text"
			[ariaLabel]="title()"
			[ngClass]="inputDesignClass()"
			mwlFlatpickr
			[placeholder]="placeholder()"
			autocomplete="off"
			[altFormat]="altFormat"
			[enableTime]="true"
			[ngModel]="selectedDate()"
			[altInput]="true"
			[mode]="'single'"
			[convertModelValue]="false"
			(flatpickrChange)="handleTimeUpdate($event)"
		/>
		}
	</div>
</ui-form-field-layout>
